// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedSearchModalController {
   $controller: any
   $scope: any
   alerts: any
   cloudStorage: any
   events: any
   i18n: any
   savedSearch: any
   constructor($controller: any, $scope: any, cloudStorage: CloudStorageService, savedSearch: SavedSearchService, events: EventService, i18n: TranslationService, alerts: AlertService) {
      // set title and current search for Saved Search modal
      this.setCurrentSearch = this.setCurrentSearch.bind(this)
      this.modalSave = this.modalSave.bind(this)
      this.$controller = $controller
      this.$scope = $scope
      this.cloudStorage = cloudStorage
      this.savedSearch = savedSearch
      this.events = events
      this.i18n = i18n
      this.alerts = alerts
      this.$scope.title = this.i18n.translations.SAVE_THIS_SEARCH
      this.setCurrentSearch()

      // instantiate base controller functionality on scope
      this.$controller('SavedSearchAndItemsBaseCtrl', {$scope: this.$scope, cloudStorage: this.cloudStorage, savedSearch: this.savedSearch, events: this.events, i18n: this.i18n, alerts: this.alerts})


      // set scope functions
      this.$scope.modalSave = this.modalSave
   }

   setCurrentSearch() {
      this.alerts.resetAlert('cloudStorageApiError')
      return this.savedSearch.setCurrentSearch()
   }

   modalSave() {
      return this.$scope.saveSearch()
         .then(() => {
            return this.$scope.close()
         })
   }
}

SavedSearchModalController.$inject = ['$controller', '$scope', 'cloudStorageService', 'savedSearchService', 'eventService', 'translationService', 'alertService']

angular.module('summonApp.controllers')
   .controller('SavedSearchModalCtrl', SavedSearchModalController)
